import { LeftOutlined } from "@ant-design/icons";
import { Grid, Typography } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

import {
  StyledBackButton,
  StyledHeadingContent,
  StyledHeadingWrapper,
  StyledTitleWrapper,
  StyledWrapper,
} from "./top-content-bar.styles";

// interface TopContentBarProps {
//   title: string;
//   renderHeadingContent?: ReactNode;
//   renderButtons?: ReactNode;
//   hasBackButton?: string;
//   ctFilter?: ReactNode;
//   setZoomLevel?: any
// }

const { useBreakpoint } = Grid;

export const ContentTopBar = ({
  title,
  renderHeadingContent,
  renderButtons,
  hasBackButton = "",
  ctFilter,
}: // setZoomLevel,
any) => {
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <StyledWrapper
      className={
        location.pathname == "/companies"
          ? "cmpny_head"
          : "cstmhead" && location.pathname === "/bookings"
          ? "bknghead"
          : "cstmhead"
      }
    >
      <StyledHeadingWrapper className="day_v_head">
        <StyledTitleWrapper>
          {hasBackButton.length ? (
            <StyledBackButton
              type="link"
              onClick={() => navigate(hasBackButton)}
            >
              <LeftOutlined width={24} height={24} />
            </StyledBackButton>
          ) : null}
          <Typography.Title
            level={3}
            ellipsis={{ tooltip: title }}
            data-testid="page-heading"
          >
            {title}
          </Typography.Title>
        </StyledTitleWrapper>

        {renderButtons && !screens.lg && (
          <div className="mltyplbtn">{renderButtons}</div>
        )}
        {renderHeadingContent && (
          <StyledHeadingContent>{renderHeadingContent}</StyledHeadingContent>
        )}

        {/* <div className="onlymbl_zoomng"> */}
        {ctFilter && <StyledHeadingContent>{ctFilter}</StyledHeadingContent>}
        {/* <div className="button_group">
            <Button
              className="btn"
              onClick={() => setZoomLevel((z: any) => Math.min(2, z + 0.1))}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z"></path>
              </svg>
            </Button>
            <Button
              className="btn"
              onClick={() => setZoomLevel((z: any) => Math.max(0.5, z - 0.1))}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M5 11V13H19V11H5Z"></path>
              </svg>
            </Button>
            <Button className="btn" onClick={() => setZoomLevel(1)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M22 12C22 17.5228 17.5229 22 12 22C6.4772 22 2 17.5228 2 12C2 6.47715 6.4772 2 12 2V4C7.5817 4 4 7.58172 4 12C4 16.4183 7.5817 20 12 20C16.4183 20 20 16.4183 20 12C20 9.53614 18.8862 7.33243 17.1346 5.86492L15 8V2L21 2L18.5535 4.44656C20.6649 6.28002 22 8.9841 22 12Z"></path>
              </svg>
            </Button>
          </div> */}
        {/* </div> */}
      </StyledHeadingWrapper>
      {renderButtons && screens.lg && (
        <div className="mltyplbtn">{renderButtons}</div>
      )}
    </StyledWrapper>
  );
};
